module.exports = __webpack_public_path__ + "media/react/components/EditPlan/EditPlanHeader/assets/icon_search_white-123474830c797d581dcd9f3d2e0d5e5b.svg";